import axios from "axios";
import qs from "qs";
let serverURI=''
export default {
  data() {
    return {
      loading: true, //遮罩
      id: this.$route.query.id, //id
      type: this.$route.query.type, //操作类型
      dataInfo: {}, //基础表单信息
      form: this.$refs["form"] //
    };
  },
  created(){serverURI=this.$store.state.serverURI},
  methods: {
    /**
     * 获取数据方法
     * @param {number} id
     * @param {object} obj
     */
    getDataInfo(id, obj) {},
    /**
     * @param {booealn} state 是否继续添加
     * @param {string} url 添加方法的api地址
     * @param {object} params 添加的参数
     * @param {string} backUrl ，返回列表的路由地址
     */
    /**
         * @param {booealn} state 是否继续添加
         * @param {string} url 添加方法的api地址
         * @param {object} params 添加的参数
         * @param {string} backUrl ，返回列表的路由地址
         */
        saveDataInfo(state, url, params, backUrl,dialog='',) {
          let form = this.$refs['form'];
          form.validate((valid) => {//验证方法
            if (valid) {
              this.loading = true;
              axios.post(serverURI+url, qs.stringify(params))
                .then(res => {
                  if (res.status == "200") {
                    if(dialog!=''){
                      this.dataInfo[dialog] = res.data;
                      this.$alert('添加成功');
                      //this.successMessage('添加成功');
                    }
                    else{
                      this.$alert('添加成功');
                      //this.successMessage('添加成功');
                      if (state) {
                        this.reset();
                      } else {
                        setTimeout(() => {
                          this.$router.push(backUrl);
                        }, 1000);
                      }
                    }
                  }
                  this.loading = false;
                }).catch(error => { this.loading = false; })
            } else {
              return false
            }
          })
        },
    saveDataInfoPromise(url, params, backUrl,dialog='') {
      let that = this;
      let p = new Promise(function(resolve,reject){
        let form = that.$refs['form'];
        form.validate((valid) => {//验证方法
          if (valid) {
            that.loading = true;
            that.$axios.post(serverURI+url, qs.stringify(params))
              .then(res => {
                if (res.status == "200") {
                  if(dialog!=''){
                    that.dataInfo[dialog] = res.data.Data;
                    that.$alert('添加成功');
                    //this.successMessage('添加成功');
                    resolve(that.dataInfo)
                    that.$router.push(backUrl);
                  }
                  else{
                    reject("出现未知错误")
                  }
                }
                that.loading = false;
              }).catch(error => { 
                that.loading = false;
                reject("出现未知错误")
              })
          } else {
            reject("表单中有字段格式不正确")
          }
        })
      })
      return p        
    },
      updateDataInfo(url, params, backUrl,isDialog=false) {
          let form = this.$refs['form'];
          form.validate((valid) => {//验证方法
              if (valid) {
                  this.loading = true;
                  axios.post(serverURI+url, qs.stringify(params))
                  .then(res => {
                    if(!isDialog){
                      this.loading = false;
                      if (res.status == "200") {
                        //this.successMessage('修改成功');
                        this.$alert('修改成功');
                        if(backUrl==''){
                          return false;
                        }else{
                          setTimeout(() => {
                            this.$router.push(backUrl);
                            //this.routerLink(backUrl);
                          }, 1000);
                        }
                      }
                    }
                    else{
                      this.loading = false;
                      if (res.status == "200") {
                        this.$alert('修改成功');
                        //this.successMessage('修改成功');
                      }
                    }
                  }).catch(error => { this.loading = false; })
              } else {
                  return false
              }
          })
      },
    /**
     *
     * @param {string} type 判断添加还是修改 save，update
     */
    isType(type) {
      return this.type == type ? true : false;
    },
    reset() {
      this.getDataInfo(this.id);
      //this.getDataInfo(0);
    }
  }
};
